export const PLP_FILTERS = [
  'bangleSize',
  'beadColour',
  'bvAverageRating',
  'centreCaratWeight',
  'centreDiamondCut',
  'centreDiamondShape',
  'centreStoneClass',
  'chainStyle',
  'design',
  'daysAvailable',
  'diamondClarity',
  'diamondColour',
  'diamondShape',
  'earringDiameter',
  'earringStyle',
  'engagementStyle',
  'gemstone',
  'gemstoneColour',
  'gender',
  'inventoryATS',
  'inventoryAvailability',
  'isHideInSearch',
  'length',
  'metalColour',
  'metalContent',
  'mHJCollection',
  'mHJPrimaryCategory',
  'mHJRetailCategory',
  'mHJSubCategory',
  'PIMColourAlphabet',
  'PIMColourZodiac',
  'PIMSizeFullRing',
  'price',
  'promotions',
  'ringStyle',
  'saleEvent',
  'settingStyle',
  'sku',
  'stoneColourDiamond',
  'stoneShape',
  'StoneClass',
  'totalCaratWeight',
  'watchBand',
  'watchCrystal',
  'watchType',
  'waterResistance',
]
